import { Button } from "antd";
import FullPageLayout from "../../../../templates/FullPageLayout";
import { useEffect, useState } from "react";
import { NeedHelp } from "../../../../atoms/CustomIcons";
import AddServiceStep2 from "./AddServiceStep2";
import { useAppDispatch, useAppSelector } from "../../../../config/hooks";
import { getServiceDetails, removeServiceDetails } from "../ducks/actions";

export default function EditService() {
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const serviceLineId = pathSegments[pathSegments.length - 2];
  const serviceId = pathSegments[pathSegments.length - 3];
  const [loading, setLoading] = useState(false);
  const serviceDetail = useAppSelector(
    (state) => state?.services?.serviceDetail
  );

  useEffect(() => {
    if (serviceId) {
      dispatch(getServiceDetails(serviceId));
    }
  }, [serviceId, dispatch]);

  useEffect(() => {
    dispatch(removeServiceDetails());
  }, [dispatch]);

  return (
    <FullPageLayout loading={serviceDetail?.loader || loading}>
      <Button className="btn-sm fixedTopBtn">
        <NeedHelp /> Need help?
      </Button>
      <div className="ServicesSteps">
        <AddServiceStep2
          setLoading={setLoading}
          companyId={companyId}
          serviceLineId={serviceLineId}
          serviceId={serviceId}
          type={serviceDetail?.data?.type as string}
          serviceDetailData={serviceDetail?.data}
        />
      </div>
    </FullPageLayout>
  );
}
